<p-toast></p-toast>
<div>
    <div *ngIf="applicationDetails && (dimicadaLogin || ddAssociateLogin)" class="card my-2">
        <div *ngIf="applicationDetails?.FarmerPersonalData" class="personal-details-container">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'PERSONAL_DETAILS' | translate}}</h5>
            </div>
            <div class="p-fluid p-formgrid grid px-3">
                <div class="field col-12 md:col-3">
                    <label>{{'FARMER_NAME'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'FATHER_NAME'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Father_name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MOTHER_NAME'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Mother_Name }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'SEX'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Gender }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'DATE_OF_BIRTH'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.DOB | date:'mediumDate' }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MOBILE'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Mobile }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'EMAIL'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Email_ID }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'EMAIL'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Aadhar_No }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'AADHAR_NO'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Email_ID }}
                        <a *ngIf="applicationDetails?.FarmerPersonalData
                              ?.Aadhaar_Copy_Upload" style="cursor: pointer" [href]="
                            applicationDetails?.FarmerPersonalData
                              ?.Aadhaar_Copy_Upload
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'VILLAGE'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Village_Code }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'BLOCK'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Block }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'DISTRICT'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.District }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'CASTE'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Caste_Code }}
                        <a *ngIf="applicationDetails?.FarmerPersonalData
                              ?.casteCertificate_Uploaded" style="cursor: pointer" [href]="
                            applicationDetails?.FarmerPersonalData
                              ?.casteCertificate_Uploaded
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'ADDRESS'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Address }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'PINCODE'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.Pin_Code }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'PPP_ID'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.PPP_ID }}
                        <a *ngIf="applicationDetails?.FarmerPersonalData
                              ?.ID_Proof_FilePath" style="cursor: pointer" [href]="
                            applicationDetails?.FarmerPersonalData
                              ?.ID_Proof_FilePath
                          " target="_blank">&nbsp;<i class="pi pi-eye" style="color: slateblue"></i></a>
                    </p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'MFMB_NO'| translate}}</label>
                    <p>{{ applicationDetails?.FarmerPersonalData?.MFMBNo }}</p>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'APPLICATION_TYPE'| translate}}</label>
                    <p>{{ applicationDetails?.AppType }}</p>
                </div>
            </div>
        </div>

        <div *ngIf="applicationDetails?.FarmerLand && applicationDetails.FarmerLand.length > 0" class="land-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'LAND_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="applicationDetails?.FarmerLand" [rows]="5" [paginator]="false"
                [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="applicationDetails.FarmerLand.length == 1 ? '100px' : applicationDetails.FarmerLand.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="text-align: center; font-size: 0.7rem;">{{'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate}}</th>
                            <th>{{'MEMBER_SNO' | translate}}</th>
                            <th>{{'OWNER_NAME' | translate}}</th>
                            <th>{{'VILLAGE' | translate}}</th>
                            <th>{{'KHEWAT' | translate}}</th>
                            <th>{{'KHEWAT_AREA' | translate}}</th>
                            <th>{{'KHEWAT_BHAG' | translate}}</th>
                            <th>{{'OWNER_HISSA' | translate}}</th>

                            <th>{{'MORABBA_NO' | translate}}</th>
                            <th>{{'KILLA_NO' | translate}}</th>

                            <th>{{'TOTAL_KANALS' | translate}}</th>
                            <th>{{'TOTAL_MARLAS' | translate}}</th>

                            <th>{{'APPLIED_KANALS' | translate}}</th>
                            <th>{{'APPLIED_MARLAS' | translate}}</th>
                            <th>{{'APPLIED_AREA' | translate}}</th>

                            <th>{{'CROP_TYPE' | translate}}</th>
                            <th>{{'YEAR' | translate}}</th>

                            <th>{{'LAND_DOC' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <div class="flex justify-content-center">
                                  <button pButton type="button" (click)="beforeCheckingLandStatus(item)"
                                      class="p-button-rounded p-button-accent p-button-primary p-button-rounded"
                                      pTooltip="{{ 'CHECK_OWNER_DETAILS_WITH_LAND_REVENUE_DEPARTMENT' | translate }}" icon="pi pi-eye"></button>
                                </div>
                            </td>
                            <td>{{ item?.memberID }}</td>
                            <td>{{ item?.OwnerName }}</td>
                            <td>{{ item?.Village }}</td>
                            <td>{{ item?.khewat }}</td>
                            <td>{{ item?.KhewatArea }}</td>
                            <td>{{ item?.Bhag }}</td>
                            <td>{{ item?.OwnerHissa }}</td>

                            <td>{{ item?.morabbaNo }}</td>
                            <td>{{ item?.killaNo }}</td>

                            <td>{{ item?.TotalkanalinKhasra }}</td>
                            <td>{{ item?.TotalmarlainKhasra }}</td>

                            <td>{{ item?.kanal }}</td>
                            <td>{{ item?.marla }}</td>                
                            <td>{{ item?.totalArea }}</td>

                            <td>{{ item?.cropType }}</td>
                            <td>{{ item?.Year }}</td>
                            <td>
                                <div *ngIf="item?.landPath != '' && item.landPath != null" class="hidden-print">
                                    <a style="cursor: pointer" [href]="item?.landPath" target="_blank"><i class="pi pi-eye" style="color: slateblue"></i></a>
                                </div>
                                <div *ngIf="item?.landPath == '' || item.landPath == null" class="hidden-print">
                                    <p>{{'N/A' |
                                    translate}}</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
            </p-table>
        </div>

        <div *ngIf="existingMIDetails && existingMIDetails.length > 0" class="existing-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'EXISTING_MI_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="existingMIDetails" [rows]="5" [paginator]="false"
                [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="existingMIDetails.length == 1 ? '100px' : existingMIDetails.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'PROGRAM_NAME' | translate}}</th>
                            <th>{{'MORABBA_NO' | translate}}</th>
                            <th>{{'KILLA_NO' | translate}}</th>
                            <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
                            <th>{{'IS_SUBSIDY_AVAIL' | translate}}</th>
                            <th>{{'YEAR' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item?.ProgrammeName }}</td>
                            <td>{{ item?.Morabba_No }}</td>
                            <td>{{ item?.Killa_No }}</td>
                            <td>{{ item?.TotalArea }}</td>
                            <td>{{ item?.Is_Subsidy_Avail }}</td>
                            <td>{{ item?.Year_subsidy }}</td>
                        </tr>
                    </ng-template>
            </p-table>
        </div>

        <div *ngIf="applicationDetails?.New_MI_Datas && applicationDetails.New_MI_Datas.length > 0" class="onfarm-details-container card my-2">
            <div class="flex justify-content-center detail-info-header py-2">
                <h5>{{'ON_FARMER_MI_COMPONENTS_AND_VENDOR_DETAILS' | translate}}</h5>
            </div>
            <p-table [value]="applicationDetails?.New_MI_Datas" [rows]="5" [paginator]="false"
                [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="existingMIDetails.length == 1 ? '100px' : existingMIDetails.length == 2 ? '200px' ? '250px'" responsiveLayout="scroll"
                [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '80rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'PROGRAMME_NAME' | translate}}</th>
                            <th>{{'LAND_DATA' | translate}}</th>
                            <th>{{'VENDOR_NAME' | translate}}</th>
                            <th>{{'TOTAL_AREA_IN_ACRE' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item.programName }}</td>
                            <td>{{ item.landData }}</td>
                            <td>{{ item.miVendorName }}</td>
                            <td>{{ item.totalArea }}</td>
                        </tr>
                    </ng-template>
            </p-table>
        </div>
    </div>
        
    <div class="card mt-2 main-container">
        <h5>{{'BASIC_DETAILS_OF_REQUEST'| translate}}</h5>
        <form [formGroup]="basicDetailsForm">
            <div class="p-fluid p-formgrid grid mt-5">
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'FARMER_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.FarmerName}}" pInputText
                        id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="VendorName">{{'VENDOR_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.VendorName}}" pInputText
                        id="VendorName" type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="JEName">{{'JE_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.JEName}}" pInputText id="JEName"
                        type="text" />
                </div>
                <!-- <div class="field col-12 md:col-6" *ngIf="!jeLogin"> -->
                <div class="field col-12 md:col-4">
                    <label htmlFor="SDOName">{{'SDO_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.SDOName}}" pInputText id="SDOName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="XENName">{{'XEN_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.XENName}}" pInputText id="XENName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="XENName">{{'DA_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DAName}}" pInputText id="DAName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="JERemarks">{{'JE_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.JERemarks}}" pInputText id="JERemarks"
                        type="text" />
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="SDORemarks">{{'SDO_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.SDORemarks}}" pInputText
                    id="SDORemarks" type="text" />
                </div>

                <div class="field col-12 md:col-4">
                    <label htmlFor="XENRemarks">{{'XEN_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.XENRemarks}}" pInputText
                    id="XENRemarks" type="text" />
                </div>
                <!-- <div class="field col-12 md:col-6" *ngIf="!(jeLogin || xenLogin)"> -->
                <div class="field col-12 md:col-4">
                    <label htmlFor="DARemarks">{{'DA_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DARemarks}}" pInputText id="DARemarks"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="DARemarks">{{'DDMI_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DDMIRemarks}}" pInputText id="DDMIRemarks"
                        type="text" />
                </div>
                <!-- <div class="field col-12 md:col-6" *ngIf="!(jeLogin || xenLogin || ddAssociateLogin)"> -->
                <div class="field col-12 md:col-4">
                    <label htmlFor="DARemarks">{{'DMICADA_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DMICADARemarks}}" pInputText id="DARemarks"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'FINANCIAL_YEAR'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.FinancialYear}}" pInputText
                        id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'APPLICATION_NO'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.AppID}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'DISTRICT'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.District}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'BLOCK'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.Block}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'VILLAGE'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.Village}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-4">
                <label htmlFor="farmerName">{{'PROGRAMME_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.ProgName}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <!-- <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'CROP'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.CropName}}" pInputText id="farmerName"
                        type="text" />
                </div> -->
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'CROP_TYPE'| translate}}</label>
                    <p-dropdown [options]="cropTypeList" formControlName="cropType"
                        placeholder="{{'SELECT_CROP_TYPE'| translate}}" optionLabel="label" optionValue="data"
                        (onChange)="getCropTypeName($event)">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || basicDetailsFormControls.cropType.touched) && basicDetailsFormControls.cropType.errors" class="invalid-feedback">
                        <div *ngIf="basicDetailsFormControls.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'CROP'| translate}}</label>
                    <p-dropdown [options]="cropBasedNames" formControlName="cropId"
                        placeholder="{{'SELECT_CROP'| translate}}" optionLabel="label" optionValue="data">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || basicDetailsFormControls.cropId.touched) && basicDetailsFormControls.cropId.errors" class="invalid-feedback">
                        <div *ngIf="basicDetailsFormControls.cropId.errors.required">{{'CROP_IS_REQ'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'SPACING'| translate}}</label>
                    <input readonly
                        value="{{physicalVerficationApplicationData?.PlantSpacing}} X {{physicalVerficationApplicationData?.RowSpacing}}"
                        pInputText id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-4">
                    <label htmlFor="farmerName">{{'AREA'| translate}}</label>
                    <input *ngIf="(ddAssociateLogin || dimicadaLogin)" formControlName="MIArea" pInputText type="number" id="MIArea" min="1" max="landArea" onwheel="this.blur()" [ngClass]="{ 'ng-invalid ng-dirty': basicDetailsFormControls.MIArea.touched || basicDetailsFormControls.MIArea.errors  }"/>
                    <input *ngIf="!(ddAssociateLogin || dimicadaLogin)" readonly value="{{landArea}}" pInputText id="farmerName"
                        type="text"/>
                        <div *ngIf="(ddAssociateLogin || dimicadaLogin) && (basicDetailsFormControls.MIArea.touched || basicDetailsFormControls.MIArea.errors)" class="invalid-feedback">
                            <div *ngIf="basicDetailsFormControls?.MIArea?.errors?.required">{{'AREA_IS_REQUIRED'| translate}}
                            </div>
                            <div *ngIf="basicDetailsFormControls?.MIArea?.errors?.min">{{'AREA_MUST_GREATER_OR_EQUAL_TO_1'| translate}}
                            </div>
                            <div *ngIf="basicDetailsFormControls?.MIArea?.errors?.max">{{'ACTUAL_AREA_SURVEYED_CANNOT_BE_GREATER_THAN_BILLED_AREA_SURVEYED'| translate}}{{ ' '+ landArea}}
                            </div>
                        </div>
                    <!-- "{{physicalVerficationApplicationData?.MIArea}}" -->
                    <!-- [(ngModel)]="landArea" -->
                </div>
                
                <div class="field col-12 md:col-12">
                    <label htmlFor="farmerName">{{'KILLA_NUMBER_OF_MI_SYSTEMS_INSTALLED'| translate}}</label>
                    <!-- <textarea readonly value="{{physicalVerficationApplicationData?.LandDetail}}" id="killaNoTA" type="text" onkeyup="autoheight('killaNoTA')"></textarea> -->
                    <!-- <textarea rows="5" cols="30" readonly value="{{physicalVerficationApplicationData?.LandDetail}}" pInputTextarea></textarea> -->
                    <textarea rows="5" cols="30" readonly value="{{physicalVerficationApplicationData?.LandDetail}}"
                        pInputTextarea></textarea>
                </div>
                <div *ngIf="xenLogin || sdoLogin" class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'SURVEY_TYPE'| translate}}</label>
                    <div class="field-radiobutton">
                        <p-radioButton name="OfficeSurvey" [ngModelOptions]="{standalone: true}" value="0"
                            (click)="getSurveyType(0)" [(ngModel)]="selectedSurveyType" inputId="0"></p-radioButton>
                        <label for="0">From Office</label>
                    </div>
                    <div class="field-radiobutton">
                        <p-radioButton name="FieldSurvey" [ngModelOptions]="{standalone: true}" value="1"
                            (click)="getSurveyType(1)" [(ngModel)]="selectedSurveyType" inputId="1"></p-radioButton>
                        <label for="1">From Field</label>
                    </div>
                </div>
            </div>
            <div class="bank-details-container">

                <!-- Pre estimation coordinates view -->
                <div class="card" *ngIf="preEstimateCoordinates && preEstimateCoordinates?.[0]?.length > 0">
                    <h5>{{'PRE_ESTIMATION_CAPTURED_GPS_COORDINATES' | translate}}</h5>
                    <div *ngIf="preEstimateCoordinates && preEstimateCoordinates.length > 0" class="dashboardTable">
                        <ng-container *ngFor="let array of preEstimateCoordinates; let i = index">
                            <p-table [value]="array" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                                responsiveLayout="scroll" [rowHover]="true" #preEstimationGeolocationsArrayTable [showCurrentPageReport]="true">
                                <ng-template pTemplate="caption">
                                    <p>Table {{ i + 1}}</p>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{'CORNER_ID' | translate}}</th>
                                        <th>{{'LATITUDE'| translate}}</th>
                                        <th>{{'LONGITUDE'| translate}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                    <tr>
                                        <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                        <td class="surveyEstimateTable">{{product.lat}}</td>
                                        <td class="surveyEstimateTable">{{product.lng}}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <!-- <div class="flex align-items-center justify-content-between">
                                        {{'IN_TOTAL_THERE_ARE'| translate}} {{array ?
                                            array.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                                    </div> -->
                                </ng-template>
                            </p-table>
                        </ng-container>
                        <p-gmap *ngIf="preEstimateCoordinates && preEstimateCoordinates.length > 0" #gmap
                            [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="preEstimateMapoptions"
                            [overlays]="preEstimationMapoverlays"></p-gmap>
                    </div>
                    <div *ngIf="preEstSurveyLandArea" class="my-2 proDataButton">
                        <p *ngIf="preEstSurveyLandArea && preEstSurveyLandArea > 0" class="survey-area">Survey Area: {{ preEstSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p>
                    </div>
                </div>
                <!-- Pre estimation coordinates view end -->

                <!-- JE GPS coordinates start -->
                <div class="gps-coordinate-container">
                    <div class="card">
                        <h5 *ngIf="!jeorxenLogin || xenLogin || sdoLogin">{{'JE_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                            translate}})</h5>
                        <h5 *ngIf="jeLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                        <div class="dashboardTable">
                            <ng-container *ngFor="let array of jegeolocationsarray; let i = index">
                                <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                    responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                    <ng-template pTemplate="caption">
                                        <p>Table {{ i + 1}}</p>
                                    </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>{{'CORNER_ID' | translate}}</th>
                                            <th>{{'LATITUDE'| translate}}</th>
                                            <th>{{'LONGITUDE'| translate}}</th>
                                            <th *ngIf="jeLogin && jegeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                        <tr>
                                            <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                            <td class="surveyEstimateTable">{{product.lat}}</td>
                                            <td class="surveyEstimateTable">{{product.lng}}</td>
                                            <td *ngIf="jeLogin" class="surveyEstimateTable">
                                                <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('jeLogin', rowIndex, i)"
                                                    class="p-button-rounded p-button-text p-button-danger"></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="summary" *ngIf="jeLogin">
                                        <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('jeLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                            class="p-button-info mr-2 mb-2"></button>
                                        <button *ngIf="jegeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('jeLogin', i)" label="{{'Delete Polygon' | translate}}"
                                            class="p-button-danger mr-2 mb-2"></button>
            
                                        <button *ngIf="jegeolocationsarray.length - 1 == i && jegeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('jeLogin', i)" label="{{'Create New Polygon' | translate}}"
                                            class="p-button-warning mr-2 mb-2"></button>
                                    </ng-template>
                                </p-table>
                            </ng-container>
                            <p-gmap  *ngIf="mapEnableJE" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="jeMapoptions"
                                [overlays]="jeMapoverlays" (onOverlayDragEnd)="onDrag('jeLogin', $event)"></p-gmap>
                        </div>
                        <div *ngIf="jeLogin" class="my-2 proDataButton flex justify-content-center">
                            <p class="invalid-feedback" *ngIf="jegeolocationsarray && jegeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                            <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('jeLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                class="p-button-secondary mr-2 mb-2"></button>
                        </div>
                    </div>
                    <div *ngIf="jeSurveyLandArea" class="my-2 proDataButton">
                        <p *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length >= 3" class="survey-area">Survey Area: {{ jeSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p>
                        <p class="invalid-feedback"
                            *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length < 4 && coordinateError">
                            {{coordinateError | translate}}</p>
                    </div>
                </div>
               <!-- JE GPS coordinates end -->
            </div>


            <!-- SDO GPS coordinates start -->
            <div *ngIf="(sdoLogin && selectedSurveyType == 1) || !jeLogin && sdogeolocationsarray?.[0]?.length > 0" class="gps-coordinate-container">
                <div class="card">
                    <h5 *ngIf="!(sdoLogin)">{{'SDO_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                        translate}})</h5>
                    <h5 *ngIf="sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div class="dashboardTable">
                        <ng-container *ngFor="let array of sdogeolocationsarray; let i = index">
                            <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                <ng-template pTemplate="caption">
                                    <p>Table {{ i + 1}}</p>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{'CORNER_ID' | translate}}</th>
                                        <th>{{'LATITUDE'| translate}}</th>
                                        <th>{{'LONGITUDE'| translate}}</th>
                                        <th *ngIf="sdoLogin && sdogeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                    <tr>
                                        <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                        <td class="surveyEstimateTable">{{product.lat}}</td>
                                        <td class="surveyEstimateTable">{{product.lng}}</td>
                                        <td *ngIf="sdoLogin" class="surveyEstimateTable">
                                            <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('sdoLogin', rowIndex, i)"
                                                class="p-button-rounded p-button-text p-button-danger"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary" *ngIf="sdoLogin">
                                    <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('sdoLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                        class="p-button-info mr-2 mb-2"></button>
                                    <button *ngIf="sdogeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('sdoLogin', i)" label="{{'Delete Polygon' | translate}}"
                                        class="p-button-danger mr-2 mb-2"></button>
        
                                    <button *ngIf="sdogeolocationsarray.length - 1 == i && sdogeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('sdoLogin', i)" label="{{'Create New Polygon' | translate}}"
                                        class="p-button-warning mr-2 mb-2"></button>
                                </ng-template>
                            </p-table>
                        </ng-container>
                        <p-gmap  *ngIf="mapEnableSDO" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="sdoMapoptions"
                            [overlays]="sdoMapoverlays" (onOverlayDragEnd)="onDrag('sdoLogin', $event)"></p-gmap>
                    </div>
                    <div *ngIf="sdoLogin" class="my-2 proDataButton flex justify-content-center">
                        <p class="invalid-feedback" *ngIf="sdogeolocationsarray && sdogeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                        <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('sdoLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                            class="p-button-secondary mr-2 mb-2"></button>
                    </div>
                </div>
                <div *ngIf="sdoSurveyLandArea" class="my-2 proDataButton">
                    <p *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ sdoSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p>
                    <p class="invalid-feedback"
                        *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length < 4 && coordinateError">
                        {{coordinateError | translate}}</p>
                </div>
            </div>
            <!-- SDO GPS coordinates end -->

            <!-- XEN GPS coordinates start -->
            <div *ngIf="(xenLogin && selectedSurveyType == 1) || !(jeorxenLogin || sdoLogin)" class="gps-coordinate-container">
                <div class="card">
                    <h5 *ngIf="!(jeorxenLogin || sdoLogin)">{{'XEN_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                        translate}})</h5>
                    <h5 *ngIf="xenLogin || sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div class="dashboardTable">
                        <ng-container *ngFor="let array of xengeolocationsarray; let i = index">
                            <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                <ng-template pTemplate="caption">
                                    <p>Table {{ i + 1}}</p>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>{{'CORNER_ID' | translate}}</th>
                                        <th>{{'LATITUDE'| translate}}</th>
                                        <th>{{'LONGITUDE'| translate}}</th>
                                        <th *ngIf="xenLogin && xengeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                    <tr>
                                        <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                        <td class="surveyEstimateTable">{{product.lat}}</td>
                                        <td class="surveyEstimateTable">{{product.lng}}</td>
                                        <td *ngIf="xenLogin" class="surveyEstimateTable">
                                            <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('xenLogin', rowIndex, i)"
                                                class="p-button-rounded p-button-text p-button-danger"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary" *ngIf="xenLogin">
                                    <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('xenLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                        class="p-button-info mr-2 mb-2"></button>
                                    <button *ngIf="xengeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('xenLogin', i)" label="{{'Delete Polygon' | translate}}"
                                        class="p-button-danger mr-2 mb-2"></button>
        
                                    <button *ngIf="xengeolocationsarray.length - 1 == i && xengeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('xenLogin', i)" label="{{'Create New Polygon' | translate}}"
                                        class="p-button-warning mr-2 mb-2"></button>
                                </ng-template>
                            </p-table>
                        </ng-container>
                        <p-gmap  *ngIf="mapEnableXEN" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="xenMapoptions"
                            [overlays]="xenMapoverlays" (onOverlayDragEnd)="onDrag('xenLogin', $event)"></p-gmap>
                    </div>
                    <div *ngIf="xenLogin" class="my-2 proDataButton flex justify-content-center">
                        <p class="invalid-feedback" *ngIf="xengeolocationsarray && xengeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                        <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('xenLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                            class="p-button-secondary mr-2 mb-2"></button>
                    </div>
                </div>
                <div *ngIf="xenLogin" class="my-2 proDataButton">
                    <p *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ xenSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p>
                    <p class="invalid-feedback"
                        *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length < 4 && coordinateError">
                        {{coordinateError | translate}}</p>
                </div>
            </div>
            <!-- XEN GPS coordinates end -->

        </form>

        <div class="isRPCaseCard">
            <div *ngIf="jeLogin" class="field col-12 md:col-12">
                <div class="field-radiobutton">
                    <p-checkbox  name="RPCase" [ngModelOptions]="{standalone: true}" value='true'
                    (click)="onSelectRPCase($event)" [(ngModel)]="selectedRPType" inputId="0"></p-checkbox>
                    <label class="isRPCase">{{'Is RP Case'| translate}}</label>
                </div>
            </div>
        </div>
        <button (click)="onBasicDetailsFormSubmit()" pButton pRipple type="button" label="Save & Next"
            class="p-button-success mr-2 mb-2"></button>
    </div>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<p-dialog header="{{ 'LAND_OWNER_DETAILS' | translate }}" [(visible)]="displayLandOwnerDialog" [modal]="true" [style]="{width: '95%',height:'auto'}"
    [maximizable]="true" [draggable]="true" [resizable]="true" (onHide)="onCloseLandOwnerDialog()">
    <div class="input-container">
      <input type="text" placeholder="Enter Kewat No" [(ngModel)]="kewatNo" />
      <button pButton pRipple type="button" type="submit" label="{{'Get Owner Details' | translate}}"
                class="p-button-success mr-2 mb-2" (click)="submitKewatNo()"></button>
      <!-- <button (click)="submitKewatNo()">Submit</button> -->
    </div>
    
    <p-progressBar mode="indeterminate" *ngIf="isLandOwnerDetFetching"></p-progressBar>
    <div *ngIf="isLandOwnerDetFetching" class="loading-text">
      <p>{{ loadingText }}</p>
    </div>
    <ng-template pTemplate="content">
      <div *ngIf="landOwnerDetails?.length > 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <p-table #landOwnerDataTable [value]="landOwnerDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'Owner_Name',
            'Bhag',
            'Khewat',
            'khewat_area',
            'owner_hissa',
            'TotalArea',
            'Year',
            ]" [rowHover]="true" dataKey="uiqueId"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="grid p-fluid mt-2 justify-content-between">
              <!-- Left side -->
              <div class="field col-12 md:col-6">
                <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
                  'Fetched Land Owner Details from Jamabandi Portal' }}</p>
              </div>
              <!-- Middle section for buttons -->
              <div class="field col-0 md:col-0">
              </div>
              <!-- Right side for search -->
              <div class="field col-12 md:col-6 align-items-center justify-content-end">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text"
                    (input)="landOwnerDataTable.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>{{'S.No'| translate}}</th>
              <th>{{'KHEWAT'| translate}}</th>
              <th>{{'OWNER_NAME'| translate}}</th>
              <th>{{'BHAG'| translate}}</th>
              <th>{{'KHEWAT_AREA'| translate}}</th>
              <th>{{'OWNER_HISSA_IN_ACRES'| translate}}</th>
              <th>{{'TOTAL_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'FARMER_APPLIED_AREA_IN_ACRES'| translate}}</th>
              <th>{{'YEAR'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{product?.Khewat}}</td>
              <td>{{product?.Owner_Name}}</td>
              <td>{{product?.Bhag}}</td>
              <td>{{product?.khewat_area}}</td>
              <td>{{product?.owner_hissa | number:'0.3-3'}}</td>
              <td>{{product?.TotalArea | number:'0.3-3'}}</td>
              <td>{{product?.TotalAreaFarmer | number:'0.3-3'}}</td>
              <td>{{product?.Year}}</td>
            </tr>
          </ng-template>
        </p-table>

        <div *ngIf="landDetailedInfo.length > 0">
          <p-table #landOwnerDetailsDataTable [value]="landDetailedInfo" [rows]="10" [paginator]="true"
            [globalFilterFields]="[
            'khatoni',
            'khewat',
            'killa',
            'must',
            'knl',
            'mrl',
            'period',
            ]" [rowHover]="true" dataKey="killa" 
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" responsiveLayout="scroll">
            <ng-template pTemplate="caption">
              <div class="grid p-fluid mt-2 justify-content-between">
                <!-- Left side -->
                <div class="field col-12 md:col-6">
                  <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">
                    {{
                    'Fetched Land Details from Jamabandi Portal' }}</p>
                </div>
                <!-- Middle section for buttons -->
                <div class="field col-0 md:col-0">
  
                </div>
                <!-- Right side for search -->
                <div class="field col-12 md:col-6 align-items-center justify-content-end">
                  <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                      (input)="landOwnerDetailsDataTable.filterGlobal($any($event.target).value, 'contains')"
                      placeholder="{{'SEARCH'| translate}}" />
                  </span>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>{{'S.No'| translate}}</th>
                <th>{{'KHATONI'| translate}}</th>
                <th>{{'KHEWAT'| translate}}</th>
                <th>{{'MORABBA_NUMBER'| translate}}</th>
                <th>{{'KILLA_NO'| translate}}</th>
                <th>{{'KANALS'| translate}}</th>
                <th>{{'MARLAS'| translate}}</th>
                <th>{{'YEAR'| translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{product?.khatoni}}</td>
                <td>{{product?.khewat}}</td>
                <td>{{product?.must}}</td>
                <td>{{product?.killa}}</td>
                <td>{{product?.knl}}</td>
                <td>{{product?.mrl}}</td>
                <td>{{product?.period}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>


      <div *ngIf="landOwnerDetails.length == 0 && !isLandOwnerDetFetching" class="p-fluid p-formgrid justify-content-center">
        <div class="field md:col-12 col-12">
          <label [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold'}">{{ landOwnerDetailsErrorMsg }}</label>
        </div>
      </div>

      <button pButton pRipple type="button" label="{{'CLOSE'| translate}}" class="p-button-secondary" style="float: right;"
        (click)="onCloseLandOwnerDialog()"></button>

    </ng-template>
</p-dialog>